export default __webpack_public_path__ + "static/media/scrap.69198b78.png";